import script from "./tpr-fullscreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./tpr-fullscreen.vue?vue&type=script&setup=true&lang=ts"

import "./tpr-fullscreen.vue?vue&type=style&index=0&id=87eab972&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87eab972"]])

export default __exports__